(function () {
  const STORAGE_KEY = 'pf_compare_devices_handles';
  const MOBILE_BREAKPOINT = 980;
  const MAX_DESKTOP = 4;
  const MAX_MOBILE = 2;

  function isMobile() {
    return typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;
  }

  function getMaxSlots() {
    return isMobile() ? MAX_MOBILE : MAX_DESKTOP;
  }

  function getHandles() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  }

  function setHandles(handles) {
    const max = getMaxSlots();
    const trimmed = handles.slice(0, max);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    return trimmed;
  }

  function syncOverlay() {
    const root = document.getElementById('CompareDevicesRoot');
    const overlay = document.getElementById('CompareDevicesOverlay');
    const slotsEl = document.getElementById('CompareDevicesSlots');
    const compareBtn = document.getElementById('CompareDevicesCompareBtn');
    const clearBtn = document.getElementById('CompareDevicesClearAll');
    if (!root || !overlay || !slotsEl || !compareBtn) return;

    const handles = getHandles();
    const max = getMaxSlots();
    const displayHandles = handles.slice(0, max);

    if (handles.length === 0) {
      overlay.classList.remove('is-visible');
      var hiddenDone = false;
      function setRootHidden() {
        if (hiddenDone) return;
        hiddenDone = true;
        root.hidden = true;
      }
      overlay.addEventListener('transitionend', setRootHidden, { once: true });
      var style = window.getComputedStyle(overlay);
      var t = style.getPropertyValue('transition-duration') || style.transitionDuration || '0s';
      var ms = parseFloat(t) * (String(t).indexOf('ms') !== -1 ? 1 : 1000);
      if (isNaN(ms) || ms <= 0) ms = 200;
      setTimeout(setRootHidden, ms + 50);
      return;
    }

    root.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    });
    compareBtn.disabled = handles.length < 2;
    if (clearBtn) clearBtn.hidden = handles.length === 0;

    slotsEl.innerHTML = '';
    for (var i = 0; i < max; i++) {
      const handle = displayHandles[i];
      const li = document.createElement('li');
      li.className = 'pf-compare-overlay__slot' + (handle ? '' : ' pf-compare-overlay__slot--empty');
      li.setAttribute('role', 'listitem');
      if (handle) {
        li.setAttribute('data-handle', handle);
        const img = document.createElement('img');
        img.alt = '';
        img.width = 48;
        img.height = 48;
        img.loading = 'lazy';
        img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="48" height="48"%3E%3Crect fill="%23f0f0f0" width="48" height="48"/%3E%3C/svg%3E';
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            if (product && product.featured_image) img.src = product.featured_image;
          })
          .catch(function () {});
        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'pf-compare-overlay__slot-remove';
        removeBtn.setAttribute('aria-label', 'Remove from compare');
        removeBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11.5285 12.4713C11.7889 12.7317 12.211 12.7317 12.4713 12.4713C12.7317 12.211 12.7317 11.7889 12.4713 11.5285L8.94273 7.99992L12.4713 4.47132C12.7317 4.21097 12.7317 3.78886 12.4713 3.52851C12.211 3.26816 11.7889 3.26816 11.5285 3.52851L7.99992 7.05711L4.47132 3.52851C4.21097 3.26816 3.78886 3.26816 3.52851 3.52851C3.26816 3.78886 3.26816 4.21097 3.52851 4.47132L7.05711 7.99992L3.52851 11.5285C3.26817 11.7889 3.26817 12.211 3.52851 12.4713C3.78886 12.7317 4.21097 12.7317 4.47132 12.4713L7.99992 8.94273L11.5285 12.4713Z" fill="currentColor"/></svg>';
        removeBtn.addEventListener('click', () => removeHandle(handle));
        li.appendChild(img);
        li.appendChild(removeBtn);
      } else {
        var clipId = 'clip0_compare_slot_' + i;
        li.innerHTML = '<span class="pf-compare-overlay__slot-placeholder" aria-hidden="true"><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#' + clipId + ')"><path d="M16.9706 11.9804C17.3388 11.9804 17.6373 11.6819 17.6373 11.3137C17.6373 10.9455 17.3388 10.6471 16.9706 10.6471L11.9804 10.6471L11.9804 5.65687C11.9804 5.28868 11.682 4.9902 11.3138 4.9902C10.9456 4.9902 10.6471 5.28868 10.6471 5.65687L10.6471 10.6471L5.65692 10.6471C5.28873 10.6471 4.99025 10.9455 4.99025 11.3137C4.99025 11.6819 5.28873 11.9804 5.65692 11.9804L10.6471 11.9804L10.6471 16.9706C10.6471 17.3388 10.9456 17.6372 11.3138 17.6372C11.682 17.6372 11.9804 17.3388 11.9804 16.9706L11.9804 11.9804L16.9706 11.9804Z" fill="currentColor"/></g><defs><clipPath id="' + clipId + '"><rect width="16" height="16" fill="white" transform="translate(0 11.3137) rotate(-45)"/></clipPath></defs></svg></span>';
      }
      slotsEl.appendChild(li);
    }
  }

  function syncCards() {
    const handles = getHandles();
    document.querySelectorAll('[data-compare-toggle]').forEach((el) => {
      const handle = el.getAttribute('data-product-handle');
      const selected = handle && handles.includes(handle);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
      el.classList.toggle('is-selected', selected);
    });
  }

  function addHandle(handle) {
    const handles = getHandles();
    if (handles.includes(handle)) return;
    if (handles.length >= getMaxSlots()) return;
    setHandles([...handles, handle]);
    syncOverlay();
    syncCards();
  }

  function removeHandle(handle) {
    const handles = getHandles().filter((h) => h !== handle);
    setHandles(handles);
    syncOverlay();
    syncCards();
  }

  function clearHandles() {
    setHandles([]);
    syncOverlay();
    syncCards();
  }

  function openDrawer(handles) {
    const drawer = document.getElementById('CompareDrawer');
    const contentEl = document.getElementById('CompareDrawerContent');
    if (!drawer || !contentEl || !handles || handles.length < 2) return;

    drawer.setAttribute('data-compare-count', String(handles.length));
    contentEl.innerHTML = '<p class="pf-compare-drawer__loading">Loading...</p>';
    drawer.open();

    var baseUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var productBlocks = [];
    var specsByLabel = {};
    var specLabelsOrder = [];
    var remaining = handles.length;

    function tryFinish() {
      remaining--;
      if (remaining > 0) return;
      var hasAny = false;
      for (var i = 0; i < handles.length; i++) {
        if (productBlocks[i] && productBlocks[i].overview) hasAny = true;
      }
      if (!hasAny) {
        contentEl.innerHTML = '<p>Unable to load comparison.</p>';
        return;
      }
      var productRowTds = '';
      for (var i = 0; i < handles.length; i++) {
        var productHtml = productBlocks[i] && productBlocks[i].overview ? productBlocks[i].overview : '<div class="pf-compare-drawer__product"></div>';
        productRowTds += '<td class="pf-compare-drawer__product-cell"><div class="pf-compare-drawer__product-cell-inner">' + productHtml + '</div></td>';
      }
      var productRow = '<tr class="pf-compare-drawer__product-row"><th scope="row" class="pf-compare-drawer__product-row-label"></th>' + productRowTds + '</tr>';
      var tableRows = specLabelsOrder.map(function (label) {
        var tds = '';
        for (var i = 0; i < handles.length; i++) {
          var val = specsByLabel[label] && specsByLabel[label][i] !== undefined ? specsByLabel[label][i] : '';
          tds += '<td>' + escapeHtml(val) + '</td>';
        }
        return '<tr><th scope="row">' + escapeHtml(label) + '</th>' + tds + '</tr>';
      }).join('');
      var colgroup = '<colgroup><col class="pf-compare-drawer__specs-col-label">';
      for (var c = 0; c < handles.length; c++) {
        colgroup += '<col class="pf-compare-drawer__specs-col-product">';
      }
      colgroup += '</colgroup>';
      contentEl.innerHTML = '<table class="pf-compare-drawer__specs" role="table">' + colgroup + '<tbody>' + productRow + tableRows + '</tbody></table>';
    }

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    var specLabelKeys = ['Model', 'Brand', 'Series', 'Screen Size', 'Screen Type', 'Storage Size', 'Color', 'Release Date', '5G Compatible', 'Connector', 'Manufacturer', 'Unlocked or Tied to Carrier?'];
    function ensureSpecLabels() {
      for (var s = 0; s < specLabelKeys.length; s++) {
        var label = specLabelKeys[s];
        if (specLabelsOrder.indexOf(label) === -1) specLabelsOrder.push(label);
      }
    }

    function buildOverviewFromProduct(product, learnMoreText) {
      if (!product || !product.title) return '';
      var img = product.featured_image ? '<a href="' + escapeHtml(product.url) + '" class="pf-compare-drawer__product-image-wrap"><img src="' + escapeHtml(product.featured_image) + '" alt="" class="pf-compare-drawer__product-image" loading="lazy" width="128" height="128"></a>' : '';
      var rating = '';
      if (product.metafields && product.metafields.reviews && product.metafields.reviews.rating && product.metafields.reviews.rating.value != null) {
        var r = product.metafields.reviews.rating.value;
        var scale = (r.scale_max != null) ? r.scale_max : 5;
        var ratingNum = (typeof r.rating === 'number') ? r.rating : parseFloat(r.rating);
        var count = (product.metafields.reviews && product.metafields.reviews.rating_count != null) ? product.metafields.reviews.rating_count : 0;
        rating = '<button type="button" class="rating-flex" aria-label="Rating"><span class="pf-product__rating-stars" style="--rating:' + Math.floor(ratingNum) + ';--rating-max:' + scale + ';--rating-decimal:0"></span><svg class="pf-product__rating-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 0.75L11.0206 6.96885H17.5595L12.2694 10.8123L14.2901 17.0312L9 13.1877L3.70993 17.0312L5.73056 10.8123L0.440492 6.96885H6.97937L9 0.75Z" fill="#4ABFA7"></path></svg><p class="pf-product__rating-text"><span aria-hidden="true">' + (ratingNum % 1 === 0 ? ratingNum : ratingNum.toFixed(1)) + '</span></p><p class="pf-product__rating-count"><span aria-hidden="true">(' + count + ')</span></p></button>';
      }
      var price = product.variants && product.variants[0] ? product.variants[0].price : (product.price || '');
      var comparePrice = product.variants && product.variants[0] && product.variants[0].compare_at_price ? product.variants[0].compare_at_price : (product.compare_at_price || '');
      if (typeof price === 'number') price = '$' + (price / 100).toFixed(2);
      if (typeof comparePrice === 'number') comparePrice = '$' + (comparePrice / 100).toFixed(2);
      var compareHtml = comparePrice ? ' <span class="pf-compare-drawer__product-price-compare"><s>' + escapeHtml(String(comparePrice)) + '</s></span>' : '';
      var learnText = (learnMoreText && learnMoreText.length) ? escapeHtml(learnMoreText) : 'Learn More';
      return '<div class="pf-compare-drawer__product" data-compare-product-block"><div class="pf-compare-drawer__product-main">' + img + '<div class="pf-compare-drawer__product-body">' + rating + '<h3 class="pf-compare-drawer__product-title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h3><div class="pf-compare-drawer__product-price"><span class="pf-compare-drawer__product-price-current">' + escapeHtml(String(price)) + '</span>' + compareHtml + '</div></div></div><a href="' + escapeHtml(product.url) + '" class="button button--primary">' + learnText + '</a></div>';
    }

    function specValueFromProduct(product, key) {
      if (!product || !product.metafields || !product.metafields.my_fields) return '';
      var m = product.metafields.my_fields;
      var v = (m[key] && m[key].value != null) ? m[key].value : (m[key] != null ? m[key] : '');
      if (key === '5g_compatible' && v) return String(v).charAt(0).toUpperCase() + String(v).slice(1);
      return v != null ? String(v) : '';
    }

    handles.forEach(function (handle, index) {
      var sectionUrl = baseUrl + 'products/' + encodeURIComponent(handle) + '?section_id=compare-drawer-content';
      var jsonUrl = baseUrl + 'products/' + encodeURIComponent(handle) + '.js';
      fetch(sectionUrl, { headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (res.ok) return res.text();
          return Promise.reject(new Error('section ' + res.status));
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var blockEl = doc.querySelector('[data-compare-product-block]');
          var section = doc.querySelector('.pf-compare-drawer-content') || (blockEl && blockEl.closest('.shopify-section'));
          var block = (section ? section.querySelector('[data-compare-product-block]') : null) || blockEl;
          var specsEl = (section ? section.querySelector('.pf-compare-drawer__specs-single[data-specs]') : null) || doc.querySelector('.pf-compare-drawer__specs-single[data-specs]');
          if (block) productBlocks[index] = { overview: block.outerHTML };
          if (specsEl) {
            var rows = specsEl.querySelectorAll('[data-spec-label]');
            for (var r = 0; r < rows.length; r++) {
              var label = rows[r].getAttribute('data-spec-label');
              var valEl = rows[r].querySelector('[data-spec-value]');
              var val = (valEl && valEl.textContent ? valEl.textContent : '').trim() || '';
              if (label) {
                if (specLabelsOrder.indexOf(label) === -1) specLabelsOrder.push(label);
                specsByLabel[label] = specsByLabel[label] || [];
                specsByLabel[label][index] = val;
              }
            }
          }
          if (!productBlocks[index]) productBlocks[index] = { overview: '' };
          tryFinish();
        })
        .catch(function () {
          var productPageUrl = baseUrl + 'products/' + encodeURIComponent(handle);
          Promise.all([
            fetch(jsonUrl, { headers: { Accept: 'application/json' } }).then(function (res) { return res.ok ? res.json() : Promise.reject(); }),
            fetch(productPageUrl, { headers: { Accept: 'text/html' } }).then(function (res) { return res.ok ? res.text() : Promise.reject(); })
          ])
            .then(function (results) {
              var product = results[0];
              var html = results[1];
              var learnMoreText = (typeof window.pfCompareLearnMore === 'string') ? window.pfCompareLearnMore : '';
              var overview = buildOverviewFromProduct(product, learnMoreText);
              if (overview) productBlocks[index] = { overview: overview };
              var specDoc = new DOMParser().parseFromString(html, 'text/html');
              var specSection = specDoc.querySelector('.pf-tech-specification');
              if (specSection) {
                var rows = specSection.querySelectorAll('.pf-tech-specification--accordion > div');
                if (!rows.length) rows = specSection.querySelectorAll('div');
                for (var r = 0; r < rows.length; r++) {
                  var ps = rows[r].querySelectorAll('p');
                  if (ps.length >= 2) {
                    var label = (ps[0].textContent || '').trim();
                    var val = (ps[1].textContent || '').trim();
                    if (label) {
                      if (specLabelsOrder.indexOf(label) === -1) specLabelsOrder.push(label);
                      specsByLabel[label] = specsByLabel[label] || [];
                      specsByLabel[label][index] = val;
                    }
                  }
                }
              }
              ensureSpecLabels();
              if (!specSection) {
                var keyMap = { 'Model': 'model', 'Brand': 'brand', 'Series': 'series', 'Screen Size': 'screen_size', 'Screen Type': 'screen_type', 'Storage Size': 'storage_size', 'Color': 'color', 'Release Date': 'release_date', '5G Compatible': '5g_compatible', 'Connector': 'connector', 'Manufacturer': 'manufacturer', 'Unlocked or Tied to Carrier?': 'unlocked_or_tied_to_carrier' };
                for (var k in keyMap) {
                  specsByLabel[k] = specsByLabel[k] || [];
                  if (specsByLabel[k][index] == null) specsByLabel[k][index] = specValueFromProduct(product, keyMap[k]);
                }
              }
              if (!productBlocks[index]) productBlocks[index] = { overview: '' };
              tryFinish();
            })
            .catch(function () {
              productBlocks[index] = { overview: '' };
              ensureSpecLabels();
              tryFinish();
            });
        });
    });
  }

  class CompareDrawer extends HTMLElement {
    constructor() {
      super();
      this.activeElement = null;
    }

    connectedCallback() {
      const overlay = this.querySelector('#CompareDrawerOverlay');
      const closeBtn = this.querySelector('#CompareDrawerClose');
      if (overlay) overlay.addEventListener('click', () => this.close());
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      this.addEventListener('keydown', (e) => {
        if (e.code === 'Escape') this.close();
      });
    }

    open() {
      this.activeElement = document.activeElement;
      this.classList.add('active');
      this.setAttribute('aria-hidden', 'false');
      var scrollY = window.scrollY || window.pageYOffset;
      this._scrollLockY = scrollY;
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      setTimeout(() => {
        const focusEl = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
        if (focusEl) focusEl.focus();
        if (typeof trapFocus === 'function') {
          const container = this.querySelector('.drawer__inner');
          if (container) trapFocus(container, this.querySelector('.drawer__close'));
        }
      }, 50);
    }

    close() {
      this.classList.remove('active');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');
      var scrollY = this._scrollLockY;
      if (typeof scrollY === 'number') window.scrollTo(0, scrollY);
      this._scrollLockY = undefined;
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
    }
  }

  customElements.define('compare-drawer', CompareDrawer);

  function init() {
    const root = document.getElementById('CompareDevicesRoot');
    if (!root) return;

    syncOverlay();
    syncCards();

    document.getElementById('CompareDevicesClearAll')?.addEventListener('click', () => {
      clearHandles();
    });

    document.getElementById('CompareDevicesCompareBtn')?.addEventListener('click', () => {
      const handles = getHandles();
      if (handles.length >= 2) openDrawer(handles);
    });

    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-compare-toggle]');
      if (!toggle) return;
      e.preventDefault();
      const handle = toggle.getAttribute('data-product-handle');
      if (!handle) return;
      const handles = getHandles();
      if (handles.includes(handle)) removeHandle(handle);
      else if (handles.length < getMaxSlots()) addHandle(handle);
    });

    window.addEventListener('resize', () => {
      const handles = getHandles();
      const max = getMaxSlots();
      if (handles.length > max) setHandles(handles.slice(0, max));
      syncOverlay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
